import React, { useState, useEffect } from "react";
import "./InventoryIssueModal.css";
import { issueInventory } from "../../services/inventoryIssueService";
import { getInventory, getInventoryByProductId } from "../../services/inventoryService"; // ✅ Updated Import

const InventoryIssueModal = ({ onClose, onIssueSuccess }) => {
    const [productId, setProductId] = useState("");
    const [quantity, setQuantity] = useState("");
    const [issuedTo, setIssuedTo] = useState("");
    const [availableQuantity, setAvailableQuantity] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [inventoryProducts, setInventoryProducts] = useState([]); // ✅ New state for inventory products

    // Load products from inventory
    useEffect(() => {
        const fetchInventoryProducts = async () => {
            try {
                const response = await getInventory(); // ✅ Fetch from Inventory endpoint
                const filteredProducts = response.data.filter(product => product.quantity > 0); // ✅ Show only products with stock
                setInventoryProducts(filteredProducts);
            } catch (error) {
                console.error("Error fetching inventory products:", error);
                setInventoryProducts([]);
            }
        };

        fetchInventoryProducts();
    }, []);

    // Load available quantity for selected product
    useEffect(() => {
        const fetchAvailableQuantity = async () => {
            if (productId) {
                try {
                    const response = await getInventoryByProductId(productId);
                    setAvailableQuantity(response.data.quantity);
                } catch (error) {
                    console.error("Error fetching available quantity:", error);
                    setAvailableQuantity(0);
                }
            }
        };

        fetchAvailableQuantity();
    }, [productId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (quantity > availableQuantity) {
            setErrorMessage("Insufficient stock available");
            return;
        }

        try {
            await issueInventory({ productId, quantity: parseInt(quantity), issuedTo });
            onIssueSuccess();
            onClose();
        } catch (error) {
            console.error("Error issuing inventory:", error);
            setErrorMessage("Failed to issue inventory. Please try again.");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Issue Inventory</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="product">Product:</label>
                        <select
                            id="product"
                            value={productId}
                            onChange={(e) => setProductId(e.target.value)}
                            required
                        >
                            <option value="">Select a product</option>
                            {inventoryProducts.map((product) => (
                                <option key={product.id} value={product.product_id}> {/* Use product.product_id */}
                                    {product.product_name} (Available: {product.quantity})
                                </option>
                            ))}
                        </select>

                    </div>
                    <div className="form-group">
                        <label htmlFor="quantity">Quantity:</label>
                        <input
                            type="number"
                            id="quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            required
                        />
                        <span className="available-quantity">
                            Available: {availableQuantity}
                        </span>
                    </div>
                    <div className="form-group">
                        <label htmlFor="issuedTo">Issued To:</label>
                        <input
                            type="text"
                            id="issuedTo"
                            value={issuedTo}
                            onChange={(e) => setIssuedTo(e.target.value)}
                            required
                        />
                    </div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <div className="form-actions">
                        <button type="submit">Issue</button>
                        <button type="button" onClick={onClose}>
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default InventoryIssueModal;
